import React, { useEffect, useState } from "react";
import axios from "axios";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./Compnents/NavbarSection/Navbar";
import Login from "./Compnents/Auth/Login";
import Register from "./Compnents/Auth/Register";
import ForgetPassword from "./Compnents/Auth/ForgetPassword";
import Footer from "./Compnents/FooterSection/Footer";
import Home from "./Compnents/HomePageSection/Home";
import ContactUs from "./Compnents/HomePageSection/ContactUs";
import GoogleAuth from "./Compnents/HomePageSection/GoogleAuth";
import Reporting from "./Compnents/OurSerSection/Reporting";
import Advertising from "./Compnents/OurSerSection/Advertising";
import Influencing from "./Compnents/OurSerSection/Influencing";
import SocialMedia from "./Compnents/OurSerSection/SocialMedia";
import CampaignManagement from "./Compnents/OurSerSection/CampaignManagement";
import BrandLaunch from "./Compnents/OurSerSection/BrandLaunch";
import Survey from "./Compnents/OurSerSection/Survey";

// Import role-based protected routes
import {
  RoleBasedRoute,
  AdminRoute,
  ReporterRoute,
  AdvertiserRoute,
  InfluencerRoute,
  RaiseYourVoiceRoute,
  PodcastRoute,
  AdvocateRoute
} from './Compnents/ProtectedRoute';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import Raise Your Voice components
import RaiseLogin from "./Compnents/RaiseYourVoiceSection/RaiseAuthSection/RaiseLogin";
import RaiseRegister from "./Compnents/RaiseYourVoiceSection/RaiseAuthSection/RaiseRegister";
import RaiseForgetPassword from "./Compnents/RaiseYourVoiceSection/RaiseAuthSection/RaiseForgetPassword";
import RasieYourVoiceLayout from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RasieYourVoiceLayout";
import RaiseYourVoiceDashboard from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaiseYourVoiceDashboard";
import RaiseHeader from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaiseHeader";
import RaiseYourVoice from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaiseYourVoice";
import RaiseProfile from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaiseProfile";
import RaiseHistory from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaiseHistory";
import RaiseComplaint from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaiseComplaint";
import RaiseUnderReviewVoice from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaisePostsSection/RaiseUnderReviewVoice";
import RasieApprovedVoice from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaisePostsSection/RasieApprovedVoice";
import RaiseRunningVoice from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaisePostsSection/RaiseRunningVoice";
import RaiseRejectedVoice from "./Compnents/RaiseYourVoiceSection/RaiseYourVoiceDashboard/RaisePostsSection/RaiseRejectedVoice";

// Import Janseva Darbar components
import DarbarLogin from "./Compnents/JansevaDarbarSection/DarbarLogin";
import DarbarRegister from "./Compnents/JansevaDarbarSection/DarbarRegister";
import DarbarForgetPassword from "./Compnents/JansevaDarbarSection/DarbarForgetPassword";
import DarbarVerifyOTP from "./Compnents/JansevaDarbarSection/DarbarVerifyOTP";

// Import Press Conference components
import PressLogin from "./Compnents/PressConferenceSection/PressAuthSection/PressLogin";
import PressRegister from "./Compnents/PressConferenceSection/PressAuthSection/PressRegister";
import PressLayout from "./Compnents/PressConferenceSection/PressDashboard/PressLayout";
import PressDashboard from "./Compnents/PressConferenceSection/PressDashboard/PressDashboard";
import FreePressConference from "./Compnents/PressConferenceSection/PressMenu/FreePressConference";
import PaidPressConference from "./Compnents/PressConferenceSection/PressMenu/PaidPressConference";
import FreeConferenceStatus from "./Compnents/PressConferenceSection/PressMenu/FreeConferenceStatus";
import PaidConferenceStatus from "./Compnents/PressConferenceSection/PressMenu/PaidConferenceStatus";
import PressPaymentHistory from "./Compnents/PressConferenceSection/PressMenu/PaymentHistory";
import PressWallet from "./Compnents/PressConferenceSection/PressMenu/walletconferance";
import Settings from "./Compnents/PressConferenceSection/PressMenu/Settings";
import PressForgotPassword from "./Compnents/PressConferenceSection/PressAuthSection/PressForgetPassword";

// Import Podcast components
import PodcastLogin from "./Compnents/Podcastpannel/PodcastAuthSection/PodcastLogin";
import PodcastRegister from "./Compnents/Podcastpannel/PodcastAuthSection/PodcastRegister";
import PodcastDashboard from "./Compnents/Podcastpannel/PodcastDashboard/PodcastDashboard";
import PodcastLayout from "./Compnents/Podcastpannel/PodcastDashboard/PodcastLayout";
import PodcastStudioRegister from "./Compnents/Podcastpannel/PodcastMenu/PodcaststudioRegister";
import PodcastBook from "./Compnents/Podcastpannel/PodcastMenu/PodcastBook";
import PodCastHistory from "./Compnents/Podcastpannel/PodcastMenu/podcasthistory";
import PodcastProfile from "./Compnents/Podcastpannel/PodcastMenu/PodcastProfile";

// Import Service/JoinOrganization components
import JoinOrganization from "./Compnents/ServiceSection/JoinOrganization";

// Import Advocate components
import AdvocateRegister from "./Compnents/advocatepannel/AdvocateRegister";
import AdvocateLogin from "./Compnents/advocatepannel/advocateLogin";
import AdvocateLayout from "./Compnents/advocatepannel/AdvocateLayout";
import AdvocateDashboard from "./Compnents/advocatepannel/AdvocateDashboard";
import AdvocateProfile from "./Compnents/advocatepannel/AdvocateProfile";
import AdvocateWallet from "./Compnents/advocatepannel/AdvocateWallet";

// Import Admin Press Conference components
import FreeConferenceList from "./Compnents/AdminPanelSection/PressConference/FreeConference/FreeConferenceList";
import PressConferenceUsers from "./Compnents/AdminPanelSection/PressConference/PressConferenceUsers";
import FreeConferenceAdminDashboard from "./Compnents/AdminPanelSection/PressConference/FreeAdminDashborad";
import PendingFreeConference from "./Compnents/AdminPanelSection/PressConference/FreeConference/PendingFreeConferance";
import ApprovedFreeConference from "./Compnents/AdminPanelSection/PressConference/FreeConference/ApprovedFreeConferance";
import FreeConferenceModify from "./Compnents/AdminPanelSection/PressConference/FreeConference/FreeConferenceAdminModify";


// Import Reporter Layout and Components
import ReporterLayout from "./Compnents/ReporterDashboardSection/ReporterLayout";
import ReporterDashboard from "./Compnents/ReporterDashboardSection/ReporterDashboard";
import ReporterAdvertisement from "./Compnents/ReporterDashboardSection/AdvertisementSection/ReporterAdvertisement";
import ReporterConference from "./Compnents/ReporterDashboardSection/ReporterConference";
import ReporterDarbar from "./Compnents/ReporterDashboardSection/ReporterDarbar";
import ReporterPodcast from "./Compnents/ReporterDashboardSection/ReporterPodcast";
import ReporterVoice from "./Compnents/ReporterDashboardSection/ReporterVoice";
import ReporterPayment from "./Compnents/ReporterDashboardSection/ReporterPayment";
import ReporterIDCards from "./Compnents/ReporterDashboardSection/ReporterIDCards";
import ReporterGetIdCard from "./Compnents/ReporterDashboardSection/ReporterGetIdCard";
import FreeConferenceDashboard from "./Compnents/ReporterDashboardSection/ConferenceSection/FreeConference/FreeConferanceDashboard";
import NewFreeConference from "./Compnents/ReporterDashboardSection/ConferenceSection/FreeConference/NewFreeConferance";
import AcceptedFreeConference from "./Compnents/ReporterDashboardSection/ConferenceSection/FreeConference/AcceptedFreeConferance";
import RejectedFreeConference from "./Compnents/AdminPanelSection/PressConference/FreeConference/RejectedFreeConferance";
import ReporterRejectedFreeConference from "./Compnents/ReporterDashboardSection/ConferenceSection/FreeConference/RejectedFreeConferance";
import CompletedFreeConference from "./Compnents/AdminPanelSection/PressConference/FreeConference/CompletedFreeConferance";
import ReporterCompletedFreeConference from "./Compnents/ReporterDashboardSection/ConferenceSection/FreeConference/CompletedFreeConferance";
import RunningFreeConference from "./Compnents/AdminPanelSection/PressConference/FreeConference/RunningFreeConferance";
import ModifiedFreeConference from "./Compnents/AdminPanelSection/PressConference/FreeConference/ModifiedFreeConferences";

// Import Admin Paid Conference components
import PaidAdminDashboard from "./Compnents/AdminPanelSection/PressConference/PaidAdminDashborad";
import PendingPaidConference from "./Compnents/AdminPanelSection/PressConference/Paidconference/PendingPaidConferance";
import ApprovedPaidConference from "./Compnents/AdminPanelSection/PressConference/Paidconference/ApprovedPaidConferance";
import RunningPaidConference from "./Compnents/AdminPanelSection/PressConference/Paidconference/RunningPaidConferance";
import RejectedPaidConference from "./Compnents/AdminPanelSection/PressConference/Paidconference/RejectedPaidConferance";
import CompletedPaidConference from "./Compnents/AdminPanelSection/PressConference/Paidconference/CompletedPaidConferance";
import ModifiedPaidConference from "./Compnents/AdminPanelSection/PressConference/Paidconference/ModifiedPaidConferences";
import PaidConferenceModify from "./Compnents/AdminPanelSection/PressConference/Paidconference/PaidConferenceAdminModify";

// Paid Conference imports
import PaidConferanceDashboard from "./Compnents/ReporterDashboardSection/ConferenceSection/PaidConference/PaidConferanceDashboard";
import NewPaidConferance from "./Compnents/ReporterDashboardSection/ConferenceSection/PaidConference/NewPaidConferance";
import AcceptedPaidConferance from "./Compnents/ReporterDashboardSection/ConferenceSection/PaidConference/AcceptedPaidConferance";
import RejectedPaidConferance from "./Compnents/ReporterDashboardSection/ConferenceSection/PaidConference/RejectedPaidConferance";
import CompletedPaidConferance from "./Compnents/ReporterDashboardSection/ConferenceSection/PaidConference/CompletedPaidConferance";
import RunningPaidConferance from "./Compnents/ReporterDashboardSection/ConferenceSection/PaidConference/RunningPaidConferance";

import PublicReporterCard from "./Compnents/ReporterDashboardSection/PublicReporterCard";
import ReporterAccount from "./Compnents/ReporterDashboardSection/ReporterAccount";
import ReporterWallet from "./Compnents/ReporterDashboardSection/ReporterWallet";
import ReporterWithdrawalRequest from "./Compnents/ReporterDashboardSection/ReporterWithdrawalRequest";

import ReporterChangePassword from "./Compnents/ReporterDashboardSection/ReporterChangePassword";
import NewAdvertise from "./Compnents/ReporterDashboardSection/AdvertisementSection/NewAdvertisement";
import AcceptedLeads from "./Compnents/ReporterDashboardSection/AdvertisementSection/AcceptedLeads";
import CompletedLeads from "./Compnents/ReporterDashboardSection/AdvertisementSection/CompletedLeads";
import RejectedLeads from "./Compnents/ReporterDashboardSection/AdvertisementSection/RejectedLeads";
import RunningLeads from "./Compnents/ReporterDashboardSection/AdvertisementSection/RunningLeads";

// Import Free Ads components
import FreeAdsDashboard from "./Compnents/ReporterDashboardSection/FreeAdsSection/FreeAdsDashboard";
import NewFreeAds from "./Compnents/ReporterDashboardSection/FreeAdsSection/NewFreeAds";
import AcceptedFreeAds from "./Compnents/ReporterDashboardSection/FreeAdsSection/AcceptedFreeAds";
import RunningFreeAds from "./Compnents/ReporterDashboardSection/FreeAdsSection/RunningFreeAds";
import CompletedFreeAds from "./Compnents/ReporterDashboardSection/FreeAdsSection/CompletedFreeAds";


// Import Reporter Raise Voice Components
import ReporterRaiseDashboard from "./Compnents/ReporterDashboardSection/ReporterRaiseYourVoiceSection/ReporterRaiseDashboard";
import ReporterGetNewRaiseVoice from "./Compnents/ReporterDashboardSection/ReporterRaiseYourVoiceSection/ReporterGetNewRaiseVoice";
import ReporterRaiseAcceptedVoice from "./Compnents/ReporterDashboardSection/ReporterRaiseYourVoiceSection/ReporterRaiseAcceptedVoice";
import ReporterGetRejectVoice from "./Compnents/ReporterDashboardSection/ReporterRaiseYourVoiceSection/ReporterGetRejectVoice";
import ReporterGetCompletedVoice from "./Compnents/ReporterDashboardSection/ReporterRaiseYourVoiceSection/ReporterGetCompletedVoice";
import ReporterGetRunningVoice from "./Compnents/ReporterDashboardSection/ReporterRaiseYourVoiceSection/ReporterGetRunningVoice";




// Import Admin Layout and Components
import AdminLayout from "./Compnents/AdminPanelSection/AdminLayout";
import AdminDashboard from "./Compnents/AdminPanelSection/AdminDashboard";
import CouponManagement from "./Compnents/AdminPanelSection/CouponManagement";
import CouponHistory from "./Compnents/AdminPanelSection/CouponHistory";
import SettingsManagement from "./Compnents/AdminPanelSection/SettingsManagement";
import CreateNewSubAdmin from "./Compnents/AdminPanelSection/CreateAndGetAdmins/CreateNewSubAdmin";
import GetAllAdmins from "./Compnents/AdminPanelSection/CreateAndGetAdmins/GetAllAdmins";
import DarbarManagement from "./Compnents/AdminPanelSection/DarbarManagement";
import Conferences from "./Compnents/AdminPanelSection/Conferences";
import OrganizationsManagement from "./Compnents/AdminPanelSection/OrganizationsManagement";
import IDCardsManagement from "./Compnents/AdminPanelSection/IdCards/IDCardsManagement";
import VerifiedIdCard from "./Compnents/AdminPanelSection/IdCards/VerifedIdCard";
import RejectedIdCard from "./Compnents/AdminPanelSection/IdCards/RejectedIdCard";
import DownloadReporterIdCards from "./Compnents/AdminPanelSection/IdCards/DownloadReporterIdCards";
import ReporterCompletedAds from "./Compnents/AdminPanelSection/ReporterCompletedAds";
import AdminGetReporterRejectedAds from "./Compnents/AdminPanelSection/AdminGetReporterRejectedAds";


import PriceSet from "./Compnents/AdminPanelSection/PriceSet";
import AdminGetAllAdvertisement from "./Compnents/AdminPanelSection/AdminGetAllAds/AdminGetAllAdvertisement";
import PendingPost from "./Compnents/AdminPanelSection/AdminGetAllAds/PendingPost";
import ApprovedPost from "./Compnents/AdminPanelSection/AdminGetAllAds/ApprovedPost";
import AcceptedByReporterPost from "./Compnents/AdminPanelSection/AdminGetAllAds/AcceptedByReporterPost";
import RejectedPost from "./Compnents/AdminPanelSection/AdminGetAllAds/RejectedPost";
import RunningPost from "./Compnents/AdminPanelSection/AdminGetAllAds/RunningPost";
import CompletedPost from "./Compnents/AdminPanelSection/AdminGetAllAds/CompletedPost";
import AdvertisementAdminModify from "./Compnents/AdminPanelSection/AdminGetAllAds/AdvertisementAdminModify";

import RaiseVoiceStatus from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/RaiseVoiceStatus";
import PendingVoice from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/PendingVoice";
import ApprovedVoice from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/ApprovedVoice";

import RejectedVoice from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/RejectedVoice";
import RunningVoice from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/RunningVoice";
import CompletedVoice from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/CompletedVoice";
import RaiseVoiceHistoryInAdmin from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/RaiseVoiceHistoryInAdmin";
import RaiseAdminModify from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/RaiseAdminModify";
import ModifiedVoice from "./Compnents/AdminPanelSection/RaiseYourVoiceSection/Modifiedvoice";

// Import Podcast Management components
import PodcastPending from "./Compnents/AdminPanelSection/Podcastsection/Podcastpending";
import PodcastBookingAdmin from "./Compnents/AdminPanelSection/Podcastsection/podcastbooking";

import CreateFreeAds from "./Compnents/AdminPanelSection/FreeAdsSection/CreateFreeAds";
import FreeAdsAdminDashboard from "./Compnents/AdminPanelSection/FreeAdsSection/FreeAdsDashboard";
import FreePendingAds from "./Compnents/AdminPanelSection/FreeAdsSection/FreePendingAds";
import FreeApprovedAds from "./Compnents/AdminPanelSection/FreeAdsSection/FreeApprovedAds";
// import FreeRejectedAds from "./Compnents/AdminPanelSection/FreeAdsSection/FreeRejectedAds";
import FreeRunningAds from "./Compnents/AdminPanelSection/FreeAdsSection/FreeRunningAds";
import FreeCompletedAds from "./Compnents/AdminPanelSection/FreeAdsSection/FreeCompletedAds";
import FreeAdsAdminModify from "./Compnents/AdminPanelSection/FreeAdsSection/FreeAdsAdminModify";

import PaymentHistory from "./Compnents/AdminPanelSection/PaymentHistory";
import WithdrawalHistory from "./Compnents/AdminPanelSection/WithdrawalHistory";
import WithdrawalRequests from "./Compnents/AdminPanelSection/WithdrawalRequests";
import RefundHistory from "./Compnents/AdminPanelSection/RefundHistory";

import AdminLogin from "./Compnents/AdminAuth/AdminLogin";
import AdminRegister from "./Compnents/AdminAuth/AdminRegister";
import AdminForgotPassword from "./Compnents/AdminAuth/AdminForgotPassword";
import AdminProfile from "./Compnents/AdminPanelSection/AdminProfile";
import AdminModify from "./Compnents/AdminPanelSection/AdminModify";

import PendingIdCards from "./Compnents/AdminPanelSection/DashboardOverviewPagesSection/PendingIdCards";
import TotalReporter from "./Compnents/AdminPanelSection/DashboardOverviewPagesSection/TotalReporter";
import TotalAdvertiser from "./Compnents/AdminPanelSection/DashboardOverviewPagesSection/TotalAdvertiser";
import AllUser from "./Compnents/AdminPanelSection/DashboardOverviewPagesSection/AllUser";
import TotalRaiseVoiceUser from "./Compnents/AdminPanelSection/DashboardOverviewPagesSection/TotalRaiseVoiceUser";
import UnVerifiedReporter from "./Compnents/AdminPanelSection/DashboardOverviewPagesSection/UnVerifiedReporter";
import TotalAdvocates from "./Compnents/AdminPanelSection/DashboardOverviewPagesSection/TotalAdvocates";

// Import User Ads Tracking components
import UserAdsTracking from "./Compnents/AdminPanelSection/AdsTracking/UserAdsTracking";
import UserAdDetailView from "./Compnents/AdminPanelSection/AdsTracking/UserAdDetailView";

// Import Advertiser Layout and Components
import AdvertiserLayout from "./Compnents/AdvertiserDashboardSection/AdvertiserLayout";
import AdvertiserDashboard from "./Compnents/AdvertiserDashboardSection/AdvertiserDashboard";
import PostAdvertisement from "./Compnents/AdvertiserDashboardSection/AdvertiserLeads/PostAdvertisement";
import AdvertiserStatus from "./Compnents/AdvertiserDashboardSection/AdvertiserLeads/AdvertiserStatus";
import PendingAdvertisements from "./Compnents/AdvertiserDashboardSection/AdvertiserLeads/ApprovedAdvertisements";
import AcceptedReporterAdvertisement from "./Compnents/AdvertiserDashboardSection/AdvertiserLeads/AcceptedReporterAdvertisement";
import CompletedAdvertisements from "./Compnents/AdvertiserDashboardSection/AdvertiserLeads/CompletedAdvertisements";
import RejectedAdvertisements from "./Compnents/AdvertiserDashboardSection/AdvertiserLeads/RejectedAdvertisements";
import UnderReviewAdvertisement from "./Compnents/AdvertiserDashboardSection/AdvertiserLeads/UnderReviewAdertisement";
import RunningAdvertisements from "./Compnents/AdvertiserDashboardSection/AdvertiserLeads/RunningAdvertisements";

import AdvertiserPaymentHistory from "./Compnents/AdvertiserDashboardSection/AdvertiserPaymentHistory";
import AdvertiserWallet from "./Compnents/AdvertiserDashboardSection/AdvertiserWallet";
import AdvertiserAddMoney from "./Compnents/AdvertiserDashboardSection/AdvertiserAddMoney";
import AdvertiserProfile from "./Compnents/AdvertiserDashboardSection/AdvertiserAccount";
import AdvertiserChangePassword from "./Compnents/AdvertiserDashboardSection/AdvertiserChangePassword";

// Import Influencer Layout and Components
import InfluencerLayout from "./Compnents/influencerdashboardsection/InfluencerLayout";
import InfluencerDashboard from "./Compnents/influencerdashboardsection/InfluencerDashboard";
import InfluencerAccount from "./Compnents/influencerdashboardsection/InfluencerAccount";
import InfluenerChangePassword from "./Compnents/influencerdashboardsection/InfluenerChangePassword";
import PublicInfluencerCard from "./Compnents/influencerdashboardsection/PublicInfluencerCard";
import InfluenerGetIdCard from "./Compnents/influencerdashboardsection/InfluenerGetIdCard";
import InfluenerIDCards from "./Compnents/influencerdashboardsection/InfluenerIDCards";
import InfluenerWallet from "./Compnents/influencerdashboardsection/InfluenerWallet";
import InfluenerWithdrawalRequest from "./Compnents/influencerdashboardsection/InfluenerWithdrawalRequest";
import InfluenerVoice from "./Compnents/influencerdashboardsection/InfluenerVoice";
import InfluenerPodcast from "./Compnents/influencerdashboardsection/InfluenerPodcast";
import InfluenerHeader from "./Compnents/influencerdashboardsection/InfluenerHeader";
import InfluenerDarbar from "./Compnents/influencerdashboardsection/InfluenerDarbar";
import InfluenerConference from "./Compnents/influencerdashboardsection/InfluenerConference";

// Import Influencer Advertisement Section
import InfluencerAdvertisement from "./Compnents/influencerdashboardsection/AdvertisementSection/InfluencerAdvertisement";
import InfluenerNewAdvertisement from "./Compnents/influencerdashboardsection/AdvertisementSection/InfluenerNewAdvertisement";
import InfluenerAcceptedLeads from "./Compnents/influencerdashboardsection/AdvertisementSection/InfluenerAcceptedLeads";
import InfluenerCompletedLeads from "./Compnents/influencerdashboardsection/AdvertisementSection/InfluenerCompletedLeads";
import InfluenerRejectedLeads from "./Compnents/influencerdashboardsection/AdvertisementSection/InfluenerRejectedLeads";
import InfluenerRunningLeads from "./Compnents/influencerdashboardsection/AdvertisementSection/InfluenerRunningLeads";

// Import Influencer Free Ads Section
import InfluenerFreeAdsDashboard from "./Compnents/influencerdashboardsection/FreeAdsSection/InfluenerFreeAdsDashboard";
import InfluenerNewFreeAds from "./Compnents/influencerdashboardsection/FreeAdsSection/InfluenerNewFreeAds";
import InfluenerAcceptedFreeAds from "./Compnents/influencerdashboardsection/FreeAdsSection/InfluenerAcceptedFreeAds";
import InfluenerRunningFreeAds from "./Compnents/influencerdashboardsection/FreeAdsSection/InfluenerRunningFreeAds";

import InfluenerCompletedFreeAds from "./Compnents/influencerdashboardsection/FreeAdsSection/InfluenerCompletedFreeAds";

// Import Influencer Raise Your Voice Section
import InfluenerRaiseDashboard from "./Compnents/influencerdashboardsection/InfluenerRaiseYourVoiceSection/InfluenerRaiseDashboard";
import InfluenerGetNewRaiseVoice from "./Compnents/influencerdashboardsection/InfluenerRaiseYourVoiceSection/InfluenerGetNewRaiseVoice";
import InfluenerRaiseAcceptedVoice from "./Compnents/influencerdashboardsection/InfluenerRaiseYourVoiceSection/InfluenerRaiseAcceptedVoice";
import InfluenerGetRejectVoice from "./Compnents/influencerdashboardsection/InfluenerRaiseYourVoiceSection/InfluenerGetRejectVoice";
import InfluenerGetCompletedVoice from "./Compnents/influencerdashboardsection/InfluenerRaiseYourVoiceSection/InfluenerGetCompletedVoice";
import InfluenerRunningVoice from "./Compnents/influencerdashboardsection/InfluenerRaiseYourVoiceSection/InfluenerRunningVoice";

//Footer Routes
import Disclaimer from "./Compnents/FooterSection/Disclaimer";
import About from "./Compnents/FooterSection/About";
import UserGuideline from "./Compnents/FooterSection/UserGuideline";
import RefundPolicy from "./Compnents/FooterSection/RefundPolicy";
import TermCondition from "./Compnents/FooterSection/Term&Condition";
import PrivacyPolicy from "./Compnents/FooterSection/PrivacyPolicy";
import Faqs from "./Compnents/FooterSection/Faqs";



// Create placeholder components for Advertiser Dashboard
const PlaceholderComponent = ({ title }) => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-800 mb-6">{title}</h1>
    <div className="bg-white rounded-xl shadow-lg p-6">
      <p className="text-gray-600">
        This page is under construction. Please check back later.
      </p>
    </div>
  </div>
);



function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const isReporterDashboard = location.pathname.startsWith("/reporter");
  const isAdminDashboard = location.pathname.startsWith("/admin");
  const isAdvertiserDashboard = location.pathname.startsWith("/advertiser");
  const isInfluencerDashboard = location.pathname.startsWith("/influencer");
  const isRaiseYourVoiceDashboard = location.pathname.startsWith("/raise");
  const isRegisterPage = location.pathname === "/register";
  const isContactPage = location.pathname === "/contact";
  const isReportingPage = location.pathname === "/ReportingServices" || location.pathname === "/OurSerSection/ReportingServices";
  const isAdvertisingPage = location.pathname === "/AdvertisingServices" || location.pathname === "/OurSerSection/AdvertisingServices";
  const isInfluencingPage = location.pathname === "/InfluencingServices" || location.pathname === "/OurSerSection/InfluencingServices";
  const isSocialMediaPage = location.pathname === "/SocialMediaServices" || location.pathname === "/OurSerSection/SocialMediaServices";
  const isCampaignManagementPage = location.pathname === "/CampaignManagementServices" || location.pathname === "/OurSerSection/CampaignManagementServices";
  const isBrandLaunchPage = location.pathname === "/BrandLaunchServices" || location.pathname === "/OurSerSection/BrandLaunchServices";
  const isSurveyPage = location.pathname === "/SurveyServices" || location.pathname === "/OurSerSection/SurveyServices";
  const isLoginPage = location.pathname === "/login";
  const isForgetPasswordPage = location.pathname === "/forgotpassword";
  const isPressLoginPage = location.pathname === "/press/login";
  const isPressRegisterPage = location.pathname === "/press/register";
  const isPressDashboard = location.pathname.startsWith("/press/") && location.pathname !== "/press/login" && location.pathname !== "/press/register";
  const isPodcastLoginPage = location.pathname === "/podcast/login";
  const isPodcastRegisterPage = location.pathname === "/podcast/register";
  const isPodcastDashboard = location.pathname.startsWith("/podcast/") && location.pathname !== "/podcast/login" && location.pathname !== "/podcast/register";
  const isAdvocateLoginPage = location.pathname === "/advocate/login";
  const isAdvocateRegisterPage = location.pathname === "/advocate/register";
  const isAdvocateDashboard = location.pathname.startsWith("/advocate/") && location.pathname !== "/advocate/login" && location.pathname !== "/advocate/register";
  const isHomepagePage = location.pathname === "/homepage";
  const shouldShowNavbar =
    !isReporterDashboard &&
    !isAdminDashboard &&
    !isAdvertiserDashboard &&
    !isInfluencerDashboard &&
    !isRaiseYourVoiceDashboard &&
    !isPressDashboard &&
    !isPodcastDashboard &&
    !isAdvocateDashboard;
  const isDisclaimerPage = location.pathname === "/disclaimer";
  const isAboutPage = location.pathname === "/about";
  const isUserGuidelinePage = location.pathname === "/guidelines";
  const isRefundPolicyPage = location.pathname === "/refundpolicy";
  const isPrivacyPolicyPage = location.pathname === "/privacypolicy";
  const shouldShowFooter = shouldShowNavbar && !isRegisterPage && !isContactPage && !isReportingPage && !isAdvertisingPage && !isInfluencingPage && !isSocialMediaPage && !isCampaignManagementPage && !isBrandLaunchPage && !isSurveyPage && !isLoginPage && !isForgetPasswordPage && !isPressLoginPage && !isPressRegisterPage && !isPressDashboard && !isPodcastLoginPage && !isPodcastRegisterPage && !isPodcastDashboard && !isAdvocateLoginPage && !isAdvocateRegisterPage && !isAdvocateDashboard && !isInfluencerDashboard && !isDisclaimerPage && !isAboutPage && !isUserGuidelinePage && !isRefundPolicyPage && !isPrivacyPolicyPage && !isHomepagePage;

  return (
    <div className="App">
      {shouldShowNavbar && <Navbar />}

      <main className={`${shouldShowNavbar ? "min-h-screen" : ""}`}>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/homepage" element={<GoogleAuth />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgotpassword" element={<ForgetPassword />} />

          {/* Footer routes */}
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/about" element={<About />} />
          <Route path="/guidelines" element={<UserGuideline />} />
          <Route path="/refundpolicy" element={<RefundPolicy />} />
          <Route path="/termscondition" element={<TermCondition />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/faqs" element={<Faqs />} />

          {/* Janseva Darbar routes */}
          <Route path="/darbar/login" element={<DarbarLogin />} />
          <Route path="/darbar/register" element={<DarbarRegister />} />
          <Route
            path="/darbar/forget-password"
            element={<DarbarForgetPassword />}
          />
          <Route
            path="/darbar/verify-otp"
            element={
              <DarbarVerifyOTP isOpen={true} onClose={() => { }} userData={{}} />
            }
          />

          {/* Press Conference routes */}
          <Route path="/press/login" element={<PressLogin />} />
          <Route path="/press/register" element={<PressRegister />} />
          <Route path="/press/forget-password" element={<PressForgotPassword />} />

          {/* Press Conference Dashboard Routes */}
          <Route
            path="/press"
            element={
              <RoleBasedRoute allowedRoles={['press']}>
                <PressLayout />
              </RoleBasedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<PressDashboard />} />
            <Route path="free-conference" element={<FreePressConference />} />
            <Route path="paid-conference" element={<PaidPressConference />} />
            <Route path="conference-status" element={<FreeConferenceStatus />} />
            <Route path="paid-conference-status" element={<PaidConferenceStatus />} />
            <Route path="wallet" element={<PressWallet />} />
            <Route path="history-payment" element={<PressPaymentHistory />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Podcast Auth Routes */}
          <Route path="/podcast/login" element={<><Navbar /><PodcastLogin /></>} />
          <Route path="/podcast/register" element={<><Navbar /><PodcastRegister /></>} />

           {/* Advocate Auth Routes */}
          <Route path="/join-organization" element={<><Navbar /><JoinOrganization /></>} />
          <Route path="/advocate/register" element={<><Navbar /><AdvocateRegister /></>} />
          <Route path="/advocate/login" element={<><Navbar /><AdvocateLogin /></>} />

          {/* Advocate Dashboard Routes */}
          <Route
            path="/advocate"
            element={
              <AdvocateRoute>
                <AdvocateLayout />
              </AdvocateRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdvocateDashboard />} />
            <Route path="cases" element={<div className="p-6"><h1 className="text-2xl font-bold">My Cases</h1><p className="text-gray-600 mt-2">Case management coming soon...</p></div>} />
            <Route path="documents" element={<div className="p-6"><h1 className="text-2xl font-bold">Documents</h1><p className="text-gray-600 mt-2">Document management coming soon...</p></div>} />
            <Route path="analytics" element={<div className="p-6"><h1 className="text-2xl font-bold">Analytics</h1><p className="text-gray-600 mt-2">Analytics dashboard coming soon...</p></div>} />
            <Route path="profile" element={<AdvocateProfile />} />
            <Route path="wallet" element={<AdvocateWallet />} />
            <Route path="history" element={<div className="p-6"><h1 className="text-2xl font-bold">History</h1><p className="text-gray-600 mt-2">History view coming soon...</p></div>} />
            <Route path="settings" element={<div className="p-6"><h1 className="text-2xl font-bold">Settings</h1><p className="text-gray-600 mt-2">Settings page coming soon...</p></div>} />
          </Route>

          {/* Podcast Dashboard Routes */}
          <Route
            path="/podcast"
            element={
              <PodcastRoute>
                <PodcastLayout />
              </PodcastRoute>
            }
          >
            <Route index element={<PodcastDashboard />} />
            <Route path="dashboard" element={<PodcastDashboard />} />
            <Route path="studio-register" element={<PodcastStudioRegister />} />
            <Route path="podcast-book" element={<PodcastBook />} />
            <Route path="booking-history" element={<PodCastHistory />} />
            <Route path="create-episode" element={<div className="p-6"><h1 className="text-2xl font-bold">Create Episode - Coming Soon</h1></div>} />
            <Route path="manage-episodes" element={<div className="p-6"><h1 className="text-2xl font-bold">Manage Episodes - Coming Soon</h1></div>} />
            <Route path="live-streaming" element={<div className="p-6"><h1 className="text-2xl font-bold">Live Streaming - Coming Soon</h1></div>} />
            <Route path="analytics" element={<div className="p-6"><h1 className="text-2xl font-bold">Analytics - Coming Soon</h1></div>} />
            <Route path="listeners" element={<div className="p-6"><h1 className="text-2xl font-bold">Listeners - Coming Soon</h1></div>} />
            <Route path="downloads" element={<div className="p-6"><h1 className="text-2xl font-bold">Downloads - Coming Soon</h1></div>} />
            <Route path="profile" element={<PodcastProfile />} />
            <Route path="settings" element={<div className="p-6"><h1 className="text-2xl font-bold">Settings - Coming Soon</h1></div>} />
          </Route>




          {/* Service routes with both paths for compatibility */}
          <Route path="/ReportingServices" element={<Reporting />} />
          <Route path="/AdvertisingServices" element={<Advertising />} />
          <Route path="/InfluencingServices" element={<Influencing />} />
          <Route path="/SocialMediaServices" element={<SocialMedia />} />
          <Route
            path="/CampaignManagementServices"
            element={<CampaignManagement />}
          />
          <Route path="/BrandLaunchServices" element={<BrandLaunch />} />
          <Route path="/SurveyServices" element={<Survey />} />

          {/* Original OurSerSection paths */}
          <Route
            path="/OurSerSection/ReportingServices"
            element={<Reporting />}
          />
          <Route
            path="/OurSerSection/AdvertisingServices"
            element={<Advertising />}
          />
          <Route
            path="/OurSerSection/InfluencingServices"
            element={<Influencing />}
          />
          <Route
            path="/OurSerSection/SocialMediaServices"
            element={<SocialMedia />}
          />
          <Route
            path="/OurSerSection/CampaignManagementServices"
            element={<CampaignManagement />}
          />
          <Route
            path="/OurSerSection/BrandLaunchServices"
            element={<BrandLaunch />}
          />
          <Route path="/OurSerSection/SurveyServices" element={<Survey />} />

          {/* Admin Auth Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          <Route
            path="/admin/forgot-password"
            element={<AdminForgotPassword />}
          />

          {/* Protected Admin Dashboard Routes */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="create/subadmin" element={<CreateNewSubAdmin />} />
            <Route path="getalldarbar" element={<DarbarManagement />} />
            <Route path="allconfrences" element={<Conferences />} />
            <Route path="settings" element={<SettingsManagement />} />
            <Route path="organization" element={<OrganizationsManagement />} />
            <Route path="idcardrequests" element={<IDCardsManagement />} />
            <Route path="approvedcards" element={<VerifiedIdCard />} />
            <Route path="rejectedcards" element={<RejectedIdCard />} />
            <Route
              path="downloadreporteridcards"
              element={<DownloadReporterIdCards />}
            />
            <Route
              path="reportercompletedads"
              element={<ReporterCompletedAds />}
            />
            <Route
              path="reporterrejectedads"
              element={<AdminGetReporterRejectedAds />}
            />
            <Route path="priceset" element={<PriceSet />} />
            <Route path="couponmanage" element={<CouponManagement />} />
            <Route path="couponhistory" element={<CouponHistory />} />
            <Route
              path="getalladvertisement"
              element={<AdminGetAllAdvertisement />}
            />

            <Route path="pendingposts" element={<PendingPost />} />
            <Route path="approvedposts" element={<ApprovedPost />} />
            <Route path="advertisement/modify" element={<AdvertisementAdminModify />} />
            <Route path="acceptedbyreporterposts" element={<AcceptedByReporterPost />} />
            <Route path="rejectedposts" element={<RejectedPost />} />
            <Route path="runningposts" element={<RunningPost />} />
            <Route path="completedposts" element={<CompletedPost />} />

            {/* Raise Your Voice  */}
            <Route path="raisevoicestatus" element={<RaiseVoiceStatus />} />
            <Route path="pendingvoice" element={<PendingVoice />} />
            <Route path="raise-your-voice/modify" element={<RaiseAdminModify />} />
            <Route path="modifiedvoice" element={<ModifiedVoice />} />
            <Route path="approvedvoice" element={<ApprovedVoice />} />

            <Route path="rejectedvoice" element={<RejectedVoice />} />
            <Route path="runningvoice" element={<RunningVoice />} />
            <Route path="completedvoice" element={<CompletedVoice />} />
            <Route path="voicehistory" element={<RaiseVoiceHistoryInAdmin />} />

            {/* Podcast Management */}
            <Route path="podcast/pending" element={<PodcastPending />} />
            <Route path="podcast/booking" element={<PodcastBookingAdmin />} />

            {/* Press Conference Management */}
            <Route path="press-conference/free-conference" element={<FreeConferenceAdminDashboard />} />
            <Route path="press-conference/free-conference/pending" element={<PendingFreeConference />} />
            <Route path="press-conference/free-conference/approved" element={<ApprovedFreeConference />} />
            <Route path="press-conference/free-conference/running" element={<RunningFreeConference />} />
            <Route path="press-conference/free-conference/rejected" element={<RejectedFreeConference />} />
            <Route path="press-conference/free-conference/completed" element={<CompletedFreeConference />} />
            <Route path="press-conference/free-conference/modified" element={<ModifiedFreeConference />} />
            <Route path="press-conference/free-conference/modify" element={<FreeConferenceModify />} />

            {/* Paid Conference Management */}
            <Route path="press-conference/paid-conference" element={<PaidAdminDashboard />} />
            <Route path="press-conference/paid-conference/pending" element={<PendingPaidConference />} />
            <Route path="press-conference/paid-conference/approved" element={<ApprovedPaidConference />} />
            <Route path="press-conference/paid-conference/running" element={<RunningPaidConference />} />
            <Route path="press-conference/paid-conference/rejected" element={<RejectedPaidConference />} />
            <Route path="press-conference/paid-conference/completed" element={<CompletedPaidConference />} />
            <Route path="press-conference/paid-conference/modified" element={<ModifiedPaidConference />} />
            <Route path="press-conference/paid-conference/modify" element={<PaidConferenceModify />} />
            <Route path="press-conference/users" element={<PressConferenceUsers />} />

            {/* Free Ads */}
            <Route path="freeadsdashboard" element={<FreeAdsAdminDashboard />} />
            <Route path="createfreeads" element={<CreateFreeAds />} />
            <Route path="freependingads" element={<FreePendingAds />} />
            <Route path="freeapprovedads" element={<FreeApprovedAds />} />
            {/* <Route path="freerejectedads" element={<FreeRejectedAds />} /> */}
            <Route path="freerunningads" element={<FreeRunningAds />} />
            <Route path="freecompletedads" element={<FreeCompletedAds />} />
            <Route path="free-ads/modify" element={<FreeAdsAdminModify />} />

            {/* User Ads Tracking */}
            <Route path="user-ads-tracking" element={<UserAdsTracking />} />
            <Route path="user-ad-details/:userId" element={<UserAdDetailView />} />


            <Route path="adStatus" element={<CreateFreeAds />} />
            <Route path="getalladmins" element={<GetAllAdmins />} />
            <Route path="payment/history" element={<PaymentHistory />} />
            <Route path="withdrawal/history" element={<WithdrawalHistory />} />
            <Route path="withdrawal/requests" element={<WithdrawalRequests />} />
            <Route path="refunds/history" element={<RefundHistory />} />
            <Route path="profile" element={<AdminProfile />} />
            <Route path="modify" element={<AdminModify />} />

            <Route path="pendingidcards" element={<PendingIdCards />} />
            <Route path="totalreporters" element={<TotalReporter />} />
            <Route path="totaladvertisers" element={<TotalAdvertiser />} />
            <Route path="alluser" element={<AllUser />} />
            <Route path="totalraisevoiceuser" element={<TotalRaiseVoiceUser />} />
            <Route path="totalraisevoiceuser" element={<TotalRaiseVoiceUser />} />
            <Route path="totalunverifiedreporter" element={<UnVerifiedReporter />} />
            <Route path="totaladvocates" element={<TotalAdvocates />} />

          </Route>



          {/* Public Raise Your Voice Auth routes */}
          <Route path="/raise/login" element={<><Navbar /><RaiseLogin /></>} />
          <Route path="/raise/register" element={<><Navbar /><RaiseRegister /></>} />
          <Route path="/raise/forget/password" element={<><Navbar /><RaiseForgetPassword /></>} />

          <Route path="/raise" element={
            <RaiseYourVoiceRoute>
              <RasieYourVoiceLayout />
            </RaiseYourVoiceRoute>
          }>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<RaiseYourVoiceDashboard />} />
            <Route path="raiseheader" element={<RaiseHeader />} />
            <Route path="raisevoice" element={<RaiseYourVoice />} />
            <Route path="history" element={<RaiseHistory />} />
            <Route path="profile" element={<RaiseProfile />} />
            <Route path="complaint" element={<RaiseComplaint />} />

            <Route path="underreviewvoice" element={<RaiseUnderReviewVoice />} />
            <Route path="approvedvoice" element={<RasieApprovedVoice />} />
            <Route path="runningvoice" element={<RaiseRunningVoice />} />
            <Route path="rejectedvoice" element={<RaiseRejectedVoice />} />

          </Route>

          {/* Protected Reporter Dashboard Routes */}
          <Route
            path="/reporter"
            element={
              <ReporterRoute>
                <ReporterLayout />
              </ReporterRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<ReporterDashboard />} />

            {/* Advertisement Routes */}
            <Route path="advertisement">
              <Route index element={<ReporterAdvertisement />} />
              <Route path="new" element={<NewAdvertise />} />
              <Route path="accepted" element={<AcceptedLeads />} />
              <Route path="completed" element={<CompletedLeads />} />
              <Route path="rejected" element={<RejectedLeads />} />
              <Route path="running" element={<RunningLeads />} />
            </Route>

            <Route path="freeads">
              <Route index element={<FreeAdsDashboard />} />
              <Route path="new" element={<NewFreeAds />} />
              <Route path="accepted" element={<AcceptedFreeAds />} />
              <Route path="running" element={<RunningFreeAds />} />
              <Route path="completed" element={<CompletedFreeAds />} />
            </Route>

            {/* Raise Your Voice Routes */}
            <Route path="raisevoice">
              <Route index element={<ReporterRaiseDashboard />} />
              <Route path="new" element={< ReporterGetNewRaiseVoice />} />
              <Route path="accepted" element={<ReporterRaiseAcceptedVoice />} />
              <Route path="rejected" element={<ReporterGetRejectVoice />} />
              <Route path="completed" element={<ReporterGetCompletedVoice />} />
              <Route path="running" element={<ReporterGetRunningVoice />} />

            </Route>

            <Route path="freeconference" element={<FreeConferenceDashboard />} />
            <Route path="freeconference/new" element={<NewFreeConference />} />
            <Route path="freeconference/accepted" element={<AcceptedFreeConference />} />
            <Route path="freeconference/rejected" element={<ReporterRejectedFreeConference />} />
            <Route path="freeconference/completed" element={<ReporterCompletedFreeConference />} />
            <Route path="freeconference/running" element={<RunningFreeConference />} />

            {/* Paid Conference Routes */}
            <Route path="paidconference" element={<PaidConferanceDashboard />} />
            <Route path="paidconference/new" element={<NewPaidConferance />} />
            <Route path="paidconference/accepted" element={<AcceptedPaidConferance />} />
            <Route path="paidconference/rejected" element={<RejectedPaidConferance />} />
            <Route path="paidconference/completed" element={<CompletedPaidConferance />} />
            <Route path="paidconference/running" element={<RunningPaidConferance />} />
            <Route path="darbar" element={<ReporterDarbar />} />
            <Route path="podcast" element={<ReporterPodcast />} />
            <Route path="voice" element={<ReporterVoice />} />
            <Route path="payment" element={<ReporterPayment />} />
            <Route path="cards" element={<ReporterIDCards />} />
            <Route path="getidcard" element={<ReporterGetIdCard />} />
            <Route path="/reporter/view/:id" element={<PublicReporterCard />} />

            <Route path="account" element={<ReporterAccount />} />
            <Route path="wallet" element={<ReporterWallet />} />
            <Route path="withdrawal" element={<ReporterWithdrawalRequest />} />
            <Route path="settings" element={<ReporterChangePassword />} />
          </Route>




          {/* Protected Advertiser Dashboard Routes */}
          <Route
            path="/advertiser"
            element={
              <AdvertiserRoute>
                <AdvertiserLayout />
              </AdvertiserRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdvertiserDashboard />} />

            {/* Advertisement Routes */}
            <Route path="post/advertisement" element={<PostAdvertisement />} />

            <Route
              path="advertiserpaymenthistory"
              element={<AdvertiserPaymentHistory />}
            />
            <Route path="wallet" element={<AdvertiserWallet />} />
            <Route path="addmoney" element={<AdvertiserAddMoney />} />

            <Route path="leads-status" element={<Navigate to="pending" replace />} />

            <Route
              path="leads-status/pending"
              element={<PendingAdvertisements />}
            />
            <Route
              path="leads-status/accepted"
              element={<AcceptedReporterAdvertisement />}
            />
            <Route
              path="leads-status/completed"
              element={<CompletedAdvertisements />}
            />
            <Route
              path="leads-status/rejected"
              element={<RejectedAdvertisements />}
            />
            <Route
              path="leads-status/underReview"
              element={<UnderReviewAdvertisement />}
            />
            <Route
              path="leads-status/running"
              element={<RunningAdvertisements />}
            />

            {/* Conference Routes */}
            <Route
              path="conferences"
              element={<PlaceholderComponent title="Create Conferences" />}
            />
            <Route
              path="get-user-conferences"
              element={<PlaceholderComponent title="Conference Status" />}
            />

            {/* Payment Routes */}

            <Route
              path="payment-historyConference"
              element={
                <PlaceholderComponent title="Payment History Conference" />
              }
            />

            {/* Account Routes */}
            <Route path="profile" element={<AdvertiserProfile />} />
            <Route path="changepassword" element={<AdvertiserChangePassword />} />
          </Route>

          {/* Protected Influencer Dashboard Routes */}
          <Route
            path="/influencer"
            element={
              <InfluencerRoute>
                <InfluencerLayout />
              </InfluencerRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<InfluencerDashboard />} />

            {/* Advertisement Routes */}
            <Route path="advertisement" element={<InfluencerAdvertisement />} />
            <Route path="advertisement/new" element={<InfluenerNewAdvertisement />} />
            <Route path="advertisement/accepted" element={<InfluenerAcceptedLeads />} />
            <Route path="advertisement/completed" element={<InfluenerCompletedLeads />} />
            <Route path="advertisement/rejected" element={<InfluenerRejectedLeads />} />
            <Route path="advertisement/running" element={<InfluenerRunningLeads />} />

            {/* Free Ads Routes */}
            <Route path="free-ads" element={<InfluenerFreeAdsDashboard />} />
            <Route path="free-ads/new" element={<InfluenerNewFreeAds />} />
            <Route path="free-ads/accepted" element={<InfluenerAcceptedFreeAds />} />
            <Route path="free-ads/running" element={<InfluenerRunningFreeAds />} />

            <Route path="free-ads/completed" element={<InfluenerCompletedFreeAds />} />

            {/* Raise Your Voice Routes */}
            <Route path="raise-your-voice" element={<InfluenerRaiseDashboard />} />
            <Route path="raise-your-voice/new" element={<InfluenerGetNewRaiseVoice />} />
            <Route path="raise-your-voice/accepted" element={<InfluenerRaiseAcceptedVoice />} />
            <Route path="raise-your-voice/rejected" element={<InfluenerGetRejectVoice />} />
            <Route path="raise-your-voice/completed" element={<InfluenerGetCompletedVoice />} />
            <Route path="raise-your-voice/running" element={<InfluenerRunningVoice />} />

            {/* ID Card Routes */}
            <Route path="id-card" element={<InfluenerGetIdCard />} />
            <Route path="id-cards" element={<InfluenerIDCards />} />

            {/* Wallet Routes */}
            <Route path="wallet" element={<InfluenerWallet />} />
            <Route path="withdrawal" element={<InfluenerWithdrawalRequest />} />

            {/* Conference Routes */}
            <Route path="conference" element={<InfluenerConference />} />

            {/* Voice and Podcast Routes */}
            <Route path="voice" element={<InfluenerVoice />} />
            <Route path="podcast" element={<InfluenerPodcast />} />
            <Route path="darbar" element={<InfluenerDarbar />} />

            {/* Public Profile */}
            <Route path="public-card" element={<PublicInfluencerCard />} />

            {/* Account Routes */}
            <Route path="profile" element={<InfluencerAccount />} />
            <Route path="changepassword" element={<InfluenerChangePassword />} />
          </Route>
        </Routes>
      </main>
      {shouldShowFooter && <Footer />}
      <ToastContainer position="top-center" autoClose={2000} />
    </div>
  );
}

export default App;
